<mat-label *ngIf="isWithLabel" class="se-time-picker-label">
    {{ label }}
</mat-label>

<div class="se-time-picker-main-container">
    <div #pickerDiv class="se-time-picker-time-picker-container">
        <ngx-timepicker-field #seTimePickerInput
                              [disabled]="disabled"
                              (timeChanged)="onTimeChanging($event)"
                              [class.se-time-picker-error]="isOnError"
                              class="se-time-picker-time-picker"
                              placeholder="data"
                              [controlOnly]="true"
                              [(ngModel)]="defaultTime"
                              [format]="clockAmPm">
        </ngx-timepicker-field>

        <mat-hint class="se-time-picker-mat-hint" *ngIf="!isOnError"></mat-hint>
        <mat-error class="se-time-picker-mat-error" *ngIf="isOnError">{{ getErrorMessage() }}</mat-error>

    </div>

    <button mat-icon-button
            matSuffix
            type="button"
            tabindex="-1"
            class="se-time-picker-reset-button se-button-no-ripple"
            *ngIf="showResetButton && !disabled"
            (click)="onResetDateTime()">
        <mat-icon>close</mat-icon>
    </button>
</div>

